import React from 'react';
import { Button, Col, Row, Table } from 'react-bootstrap';
import { useAuth } from '../../hooks/useAuth';
import { WebApiCalls } from '../../webApiCalls/WebApiCalls';
import { toast } from 'react-toastify';
import { useLocalStorage } from '../../hooks/useLocalStorage';
import { calculateAnswered } from '../../helpers/utils';

const ReviewQuestions = ({ qData, progress, setReviewMode, setStep }) => {
    const [user, setUser] = useLocalStorage('user', null);
    const { getToken } = useAuth();
    return (
        <Row className="d-flex justify-content-center">
            <Col xs={12} md={10} lg={8} className="shadow-lg p-4 m-3 bg-white rounded">
                <div>
                    <h2 className="text-center mb-4">Review Questionnaire ({calculateAnswered(qData)}/12)</h2>
                    <div className="table-responsive">
                        <Table bordered hover className="table-striped">
                            <thead className="table-success text-center">
                                <tr>
                                    <th className="w-50">Title</th>
                                    <th className="w-50">Answer</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Object.entries(qData).map(([key, value]) => {
                                    return (
                                        <tr key={key}>
                                            <td className="fw-bold text-break align-middle">{key}</td>
                                            <td className="text-break">
                                                {Object.values(value).map((val, index) => {
                                                    if (Array.isArray(val)) {
                                                        // ✅ Handle array inside object
                                                        return <div key={index}>{val.join(', ')}</div>;
                                                    } else if (typeof val === 'object' && val !== null) {
                                                        // ✅ Handle nested object inside object
                                                        return (
                                                            <div key={index} className="mb-2">
                                                                {Object.entries(val).map(([subKey, subValue]) => (
                                                                    <div key={subKey}>
                                                                        <strong>{subKey}:</strong> {Array.isArray(subValue) ? subValue.join(', ') : subValue}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        );
                                                    } else {
                                                        // ✅ Handle normal string/number/etc.
                                                        return <div key={index}>{typeof val === 'number' ? null : val}</div>;
                                                    }
                                                })}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </Table>
                    </div>
                    <div className=" d-flex gap-2 justify-content-center">
                        <Button
                            className="theme-cancel-btn"
                            onClick={() => {
                                setStep(1);
                                setReviewMode(false);
                            }}
                        >
                            Edit
                        </Button>
                        <Button
                            onClick={() => {
                                const webApi = new WebApiCalls();
                                const token = getToken();
                                if (token) {
                                    webApi
                                        .saveDemographics(token, {
                                            demographics: JSON.stringify({ ...qData, progress })
                                        })
                                        .then((res) => {
                                            if (res?.code === 200) {
                                                toast.success(res?.desc);
                                                setStep(0);
                                                setUser({
                                                    ...user,
                                                    demographics: JSON.stringify(qData)
                                                });
                                                setReviewMode(false);
                                            }
                                        })
                                        .catch((err) => {
                                            console.log(err);
                                        });
                                }
                            }}
                            className="theme-btn"
                        >
                            Submit
                        </Button>
                    </div>
                </div>
            </Col>
        </Row>
    );
};

export default ReviewQuestions;
